import { render, staticRenderFns } from "./UllageReportEs.vue?vue&type=template&id=313c6314&scoped=true&"
import script from "./UllageReportEs.vue?vue&type=script&lang=js&"
export * from "./UllageReportEs.vue?vue&type=script&lang=js&"
import style0 from "./UllageReportEs.vue?vue&type=style&index=0&id=313c6314&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c6314",
  null
  
)

export default component.exports